import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { StatusPill } from "@/components/shared/StatusPill";
import { Button } from "@/components/ui/button";
import { Plug } from "lucide-react";
import { toast } from "sonner";

export default function Integrations() {
  const [integrations, setIntegrations] = useState([]);
  const load = () => api.get("/admin/integrations").then((r) => setIntegrations(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const toggle = async (i) => {
    const status = i.status === "connected" ? "not_connected" : "connected";
    try { await api.put(`/admin/integrations/${i.provider}`, { provider: i.provider, status, config: i.config || {} }); toast.success("Integration updated"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div>
      <PageHeader title="Integrations" subtitle="Shared Atlas integration framework — deep integrations arrive later" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="admin-integrations-grid">
        {integrations.map((i) => (
          <div key={i.provider} className="bg-white border border-slate-200 rounded-xl p-5 flex items-center gap-4" data-testid={`integration-${i.provider}`}>
            <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center"><Plug className="w-5 h-5 text-slate-500" /></div>
            <div className="flex-1">
              <div className="font-heading font-semibold text-slate-900">{i.name}</div>
              <p className="text-xs text-slate-400">{i.category}</p>
            </div>
            <StatusPill value={i.status === "connected" ? "active" : "draft"} tone={i.status === "connected" ? "success" : "neutral"} />
            <Button size="sm" variant="outline" onClick={() => toggle(i)} data-testid={`integration-toggle-${i.provider}`}>{i.status === "connected" ? "Disconnect" : "Connect"}</Button>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-400 mt-4">Note: connection toggles are illustrative for Atlas 0.1. Live OAuth flows (Slack first) are planned next.</p>
    </div>
  );
}
